// extracted by mini-css-extract-plugin
export var ContactSection = "v_bK";
export var CtaSection = "v_bN";
export var InfoBoxIcon = "v_bM";
export var InfoBoxLink = "v_bL";